import { propClassName } from '@/styles/404';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils';

export interface Http404DescriptionProps extends ComponentProps<'div'> {
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

export const Http404DescriptionComponent: Component<Http404DescriptionProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('description_colors', colors);
  const sizeClassName = propClassName('description_size', size);
  const variantClassName = propClassName('description_variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
